import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/permission' //路由守卫

import 'normalize.css/normalize.css' //引入浏览器统一CSS样式

import ElementUI from 'element-ui' //引入elementui库
import 'element-ui/lib/theme-chalk/index.css'

import 'vueperslides/dist/vueperslides.css'   //引入vueperslides
import '@/styles/element-variables.scss'
import '@/styles/element-ui.scss'
import '@/styles/index.scss' // 公共样式


import dialog from '@/components/dialog' //全局封装dialog
Vue.component('Dialog', dialog)

import pagination from '@/components/pagination' //封装翻页
Vue.component('Pagination', pagination)

import ElImageViewer from "element-ui/packages/image/src/image-viewer";
Vue.component('ElImageViewer', ElImageViewer)


import rules from '@/utils/formCheck'// 全局方法挂载 表单验证方法
Vue.prototype.$rules = rules

import * as redirectUrl from '@/utils/url_redirection'// 全局方法挂载 链接跳转
Vue.prototype.$redirectUrl = redirectUrl

import i18n from './lang' // internationalization //多语言
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

import * as gfn from '@/utils/global_method'// 全局方法挂载
Vue.prototype.$gfn = gfn

// Vue.directive('removeAriaHidden', {
//   bind(el, binding) {
//     let ariaEls = el.querySelectorAll('.el-popover,.el-popper');
//     // 遍历打印每个元素的 aria-hidden 属性
//     ariaEls.forEach((item) => {
//       item.removeAttribute("aria-hidden");
//     });
//   }
// })
import * as rtext from '@/utils/rtext' //脱敏
for (let key in rtext){
  Vue.filter(key,rtext[key])
}

import * as filters from '@/utils/dictionary' //自定义数字字典
for (let key in filters){
  Vue.filter(key,filters[key])
}
Vue.prototype.$filters = filters

import directive from '@/utils/directives/index' //自定义指令 集
Vue.use(directive)

import '@/icons' // icon 引入图标
import { Icon } from "@iconify/vue2"; //引入iconify图标库
Vue.component('Icon', Icon)

Vue.config.productionTip = false

// 路由获取
import {generateRedirect} from "@/utils/skip"
Vue.prototype.$generateRedirect = generateRedirect

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
